import {observable, action} from "mobx";
import jwtDecode from "jwt-decode";

export default class Authorization {

    @observable isAuthorize = false;
    @observable token = "";
    @observable userType = null;

    @action setAuthorize(isAuthorize, token) {
        this.token = token;
        this.isAuthorize = isAuthorize;
        this.userType = null;

        if (!isAuthorize) {
            localStorage.removeItem("faq-token");
        } else {
            localStorage.setItem("faq-token", token);

            const decoded = jwtDecode(token);

            this.userType = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/authenticationmethod"];
        }
    }

    constructor(rootStore) {
        this.rootStore = rootStore;

        const token = localStorage.getItem('faq-token');

        if (!!token) {
            this.setAuthorize(true, token);
        }
    }
}